// extracted by mini-css-extract-plugin
export default {"sectionTitle":"WebinarContent_sectionTitle__xnpP5","mobile":"WebinarContent_mobile__240JV","description":"WebinarContent_description__DIUcQ"};